"use strict";import{html as i}from"@cisco-u/base";export function blackULogo({height:e="100%",width:l=269,hidden:t=!1,title:r=""}={}){return i`<svg
    width=${l}
    height=${e}
    viewBox="0 0 269 264"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${t?"true":"false"}"
    aria-label="${r}"
  >
    <circle
      cx="22.7168"
      cy="22.7168"
      r="22.7168"
      transform="matrix(1 0 0 -1 204 250.46)"
      fill="#0D0D0E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.54785 0V154.006C3.54785 209.359 48.4205 254.232 103.774 254.232C159.127 254.232 204 209.359 204 154.006V0H152.967V154.006C152.967 181.174 130.942 203.199 103.774 203.199C76.6051 203.199 54.5805 181.174 54.5805 154.006V0H3.54785Z"
      fill="#0D0D0E"
    />
  </svg>`}
//# sourceMappingURL=black-u-logo.js.map
